type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      <div className={`flex items-center gap-2.5 ${isCenter ? 'justify-center' : ''}`}>
        <span className="h-px w-6 bg-accent-500" />
        <span className="font-label text-[11px] uppercase tracking-[0.24em] text-primary-700">
          {eyebrow}
        </span>
      </div>
      <h3 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[2rem]">
        {title}
      </h3>
      {desc ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
      ) : null}
    </div>
  );
}